<template>
  <div ref="topSticky" class="sticky z-10">
    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useGlobalTopSticky } from 'vue_features/shared/composables/use_global_top_sticky'


const topSticky = ref(null)
onMounted(() => useGlobalTopSticky().addSticky(topSticky))
onBeforeUnmount(() => useGlobalTopSticky().removeSticky(topSticky))

</script>
